
/**
 * Format position type to human-readable string.
 * @param {string} type - The position type.
 * @returns {string} - Formatted position string.
 */
export function formatPosition(type) {
    if (type === "administration-finance") {
        return " Administration & Finance";
    } else if (type === "co-founder-cto") {
        return "Co-Founder & CTO";
    } else if (type === "co-founder-coo") {
        return "Co-Founder & COO";
    } else if (type === "co-founder-ceo") {
        return "Co-Founder & CEO";
    } else if (type === "customer-service-representative") {
        return "Customer Service Representative";
    } else if (type === "data-entry-operator") {
        return "Data Entry Operator";
    } else if (type === "designer-front-end") {
        return "Designer & Front End";
    } else if (type === "developer") {
        return "Developer";
    } else if (type === "junior-reservations-sales-agent") {
        return "Junior Reservations & Sales Agent";
    } else if (type === "product-manager") {
        return "Product Manager";
    } else if (type === "reservations-csr-manager") {
        return "Reservations & CSR Manager";
    } else if (type === "reservations-sales-agent") {
        return "Reservations & Sales Agent";
    } else if (type === "sales-manager") {
        return "Sales Manager";
    } else if (type === "account-manager") {
        return "Account Manager";
    } else if (type == "customer-service-manager") {
        return "Customer Service Manager";
    } else if (type === "customer-service-claims-manager") {
        return "Customer Service & Claims Manager";
    } else {
        return "Unkanow";
    }
}

/**
 * Format role type to human-readable string.
 * @param {string} type - The role type.
 * @returns {string} - Formatted role string.
 */
export function formatRole(type) {
    if (type === "admin") {
        return "Admin";
    } else if (type === "super_admin") {
        return "Super Admin";
    } else if (type === "manager") {
        return "Manager";
    } else if (type === "user") {
        return "User";
    } else if (type === "support") {
        return "Support";
    }
    return "Unknown";
}
